import {
    VDR_DATA_USER,
    VDR_DATA_USER_SUCCESS,
    VDR_DATA_USER_ERROR,
    VDR_DOCUMENT_TYPE,
    VDR_DOCUMENT_TYPE_SUCCESS,
    VDR_DOCUMENT_TYPE_ERROR,
    VDR_DELIVERY_ORDER,
    VDR_DELIVERY_ORDER_SUCCESS,
    VDR_DELIVERY_ORDER_ERROR,
    VDR_SUPPLIER,
    VDR_SUPPLIER_SUCCESS,
    VDR_SUPPLIER_ERROR,
    VDR_EQUIPMENT,
    VDR_EQUIPMENT_SUCCESS,
    VDR_EQUIPMENT_ERROR,
    VDR_SERIAL,
    VDR_SERIAL_SUCCESS,
    VDR_SERIAL_ERROR,
    VDR_STATUS_REVIEW,
    VDR_STATUS_REVIEW_SUCCESS,
    VDR_STATUS_REVIEW_ERROR,
    VDR_USER_REVIEW,
    VDR_USER_REVIEW_SUCCESS,
    VDR_USER_REVIEW_ERROR,
    VDR_STATUS_DOCS,
    VDR_STATUS_DOCS_SUCCESS,
    VDR_STATUS_DOCS_ERROR,
    VDR_UNIT_HEALTH,
    VDR_UNIT_HEALTH_SUCCESS,
    VDR_UNIT_HEALTH_ERROR,
    VDR_LIST,
    VDR_LIST_SUCCESS,
    VDR_LIST_ERROR,
    VDR_LIST_SEARCH_CHANGE,
    VDR_LIST_PAGE_SET,
    VDR_VALIDATE_MODAL_SET,
    VDR_VALIDATE_CHANGE_SET,
    VDR_VALIDATE,
    VDR_VALIDATE_SUCCESS,
    VDR_VALIDATE_ERROR,
    VDR_CHECKLIST_VALIDATION,
    VDR_CHECKLIST_VALIDATION_SUCCESS,
    VDR_CHECKLIST_VALIDATION_ERROR,
    VDR_SEE_VALIDATE_MODAL_SET,
    VDR_SEE_VALIDATE_CHANGE_SET,
    VDR_SEE_VALIDATE,
    VDR_SEE_VALIDATE_SUCCESS,
    VDR_SEE_VALIDATE_ERROR,
} from "../../actions";


const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    user: {
        loading: false,
        data: []
    },
    documenttype: {
        loading: false,
        data: []
    },
    deliveryorder: {
        loading: false,
        data: []
    },
    supplier: {
        loading: false,
        data: []
    },
    equipment: {
        loading: false,
        data: []
    },
    serial: {
        loading: false,
        data: []
    },
    statusreview: {
        loading: false,
        data: []
    },
    userreview: {
        loading: false,
        data: []
    },
    unithealth: {
        loading: false,
        data: []
    },
    validate: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    checklistvalidation: {
        loading: false,
        data: []
    },
    statusdocs: {
        loading: false,
        data: []
    },
    detailseevalidate: {
        loading: false,
        data: []
    },
    seevalidate: {
        loading: false,
        data: []
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            deliveryorder: '',
            documenttype: '',
            statusreview: '',
            userreview: '',
            serial: '',
            equipment: '',
            supplier: '',
            idstatusreview: '',
            urgent: '',
            unithealth:''
        },
        value: {
            deliveryorder: '',
            documenttype: '',
            statusreview: '',
            userreview: '',
            serial: '',
            equipment: '',
            supplier: '',
            idstatusreview: '',
            urgent: '',
            unithealth: ''
        }
    }
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case VDR_DATA_USER:
            return {
                ...state,
                loading: true,
                user: {
                    ...state.user
                }
            }
        case VDR_DATA_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                user: {
                    ...state.user,
                    ...action.payload
                }
            }
        case VDR_DATA_USER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case VDR_DOCUMENT_TYPE:
            return {
                ...state,
                loading: true,
                documenttype: {
                    ...state.documenttype
                }
            }
        case VDR_DOCUMENT_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                documenttype: {
                    ...state.documenttype,
                    ...action.payload
                }
            }
        case VDR_DOCUMENT_TYPE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case VDR_DELIVERY_ORDER:
            return {
                ...state,
                loading: true,
                deliveryorder: {
                    ...state.deliveryorder
                }
            }
        case VDR_DELIVERY_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                deliveryorder: {
                    ...state.deliveryorder,
                    ...action.payload
                }
            }
        case VDR_DELIVERY_ORDER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case VDR_SUPPLIER:
            return {
                ...state,
                loading: true,
                supplier: {
                    ...state.supplier
                }
            }
        case VDR_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                supplier: {
                    ...state.supplier,
                    ...action.payload
                }
            }
        case VDR_SUPPLIER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case VDR_EQUIPMENT:
            return {
                ...state,
                loading: true,
                equipment: {
                    ...state.equipment
                }
            }
        case VDR_EQUIPMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                equipment: {
                    ...state.equipment,
                    ...action.payload
                }
            }
        case VDR_EQUIPMENT_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case VDR_SERIAL:
            return {
                ...state,
                loading: true,
                serial: {
                    ...state.serial
                }
            }
        case VDR_SERIAL_SUCCESS:
            return {
                ...state,
                loading: false,
                serial: {
                    ...state.serial,
                    ...action.payload
                }
            }
        case VDR_SERIAL_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case VDR_STATUS_REVIEW:
            return {
                ...state,
                loading: true,
                statusreview: {
                    ...state.statusreview
                }
            }
        case VDR_STATUS_REVIEW_SUCCESS:
            return {
                ...state,
                loading: false,
                statusreview: {
                    ...state.statusreview,
                    ...action.payload
                }
            }
        case VDR_STATUS_REVIEW_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case VDR_USER_REVIEW:
            return {
                ...state,
                loading: true,
                userreview: {
                    ...state.userreview
                }
            }
        case VDR_USER_REVIEW_SUCCESS:
            return {
                ...state,
                loading: false,
                userreview: {
                    ...state.userreview,
                    ...action.payload
                }
            }
        case VDR_USER_REVIEW_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case VDR_STATUS_DOCS:
            return {
                ...state,
                loading: true,
                statusdocs: {
                    ...state.statusdocs
                }
            }
        case VDR_STATUS_DOCS_SUCCESS:
            return {
                ...state,
                loading: false,
                statusdocs: {
                    ...state.statusdocs,
                    ...action.payload
                }
            }
        case VDR_STATUS_DOCS_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case VDR_UNIT_HEALTH:
            return {
                ...state,
                loading: true,
                unithealth: {
                    ...state.unithealth
                }
            }
        case VDR_UNIT_HEALTH_SUCCESS:
            return {
                ...state,
                loading: false,
                unithealth: {
                    ...state.unithealth,
                    ...action.payload
                }
            }
        case VDR_UNIT_HEALTH_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case VDR_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list,
                    data: []
                }
            }

        case VDR_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload

                }
            }
        case VDR_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case VDR_LIST_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                }
            }
        case VDR_LIST_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case VDR_VALIDATE_MODAL_SET:
            return {
                ...state,
                validate: {
                    ...state.validate,
                    modal: action.payload
                }
            }
        case VDR_VALIDATE_CHANGE_SET:
            return {
                ...state,
                validate: {
                    ...state.validate,
                    data: {
                        ...state.validate.data,
                        ...action.payload
                    }
                }
            }
        case VDR_VALIDATE:
            return {
                ...state,
                validate: {
                    ...state.validate,
                    loading: false
                }
            }
        case VDR_VALIDATE_SUCCESS:
            return {
                ...state,
                validate: {
                    ...state.validate,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case VDR_VALIDATE_ERROR:
            return {
                ...state,
                validate: {
                    ...state.validate,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case VDR_CHECKLIST_VALIDATION:
            return {
                ...state,
                loading: true,
                checklistvalidation: {
                    ...state.checklistvalidation
                }
            }
        case VDR_CHECKLIST_VALIDATION_SUCCESS:
            return {
                ...state,
                loading: false,
                checklistvalidation: {
                    ...state.checklistvalidation,
                    ...action.payload
                }
            }
        case VDR_CHECKLIST_VALIDATION_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case VDR_SEE_VALIDATE_MODAL_SET:
            return {
                ...state,
                seevalidate: {
                    ...state.seevalidate,
                    modal: action.payload
                }
            }
        case VDR_SEE_VALIDATE_CHANGE_SET:
            return {
                ...state,
               detailseevalidate: {
                    ...state.detailseevalidate,
                    data: {
                        ...state.detailseevalidate.data,
                        ...action.payload
                    }
                }
            }
        case VDR_SEE_VALIDATE:
            return {
                ...state,
               seevalidate: {
                    ...state.seevalidate,
                    loading: false
                }
            }
        case VDR_SEE_VALIDATE_SUCCESS:
            return {
                ...state,
                seevalidate: {
                    ...state.seevalidate,
                    ...action.payload
                }
            }
        case VDR_SEE_VALIDATE_ERROR:
            return {
                ...state,
                seevalidate: {
                    ...state,
                    loading: false,
                    error: true
                }
            }

        default:
            return { ...state };
    }
};


